import { useTranslation } from "react-i18next";
import { SceneGif as SceneGifType } from "@ltypes/scene";
import TextField from "@components/forms/TextField/TextField";
import GifSelector from "@components/forms/GifSelector/GifSelector";
import "./SceneGif.scss";

type SceneGifProps = {
    scene: SceneGifType,
    onChange: (field: string, value: string|number|boolean) => void,
};

function SceneGif(props: SceneGifProps) {

    const { t } = useTranslation();

    return (
        <div className="row g-0">
            <div className="col-12">
                <div className="row g-3">
                    <div className="col">
                        <div className="row g-3">
                            <div className="col-12">
                                <TextField label={t('page.scenes.data.display_duration')} value={props.scene.display_duration} onChange={(value: string) => props.onChange('display_duration', value)}/>
                            </div>
                        </div>
                    </div>
                    <div className="col-auto">
                        <div className="selected-gif" style={{ backgroundImage: `url('${process.env.REACT_APP_API_URL}/media/gifs/${props.scene.gif_id}.gif')` }}><span className="selected-gif-label">{t('page.scenes.data.selected_gif')}</span></div>
                    </div>
                </div>
            </div>
            <div className="col-12">
                <GifSelector label="GIF" value={props.scene.gif_id} onChange={(gifId: number) => props.onChange('gif_id', gifId)}/>
            </div>
        </div>
    );
}

export default SceneGif;
